<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="10.5" height="11.999" viewBox="0 0 10.5 11.999" style="margin-top: 2px">
		<g id="Group_20565" data-name="Group 20565" transform="translate(-2283.596 -9537.021)">
			<path
				id="Path_19252"
				data-name="Path 19252"
				d="M1.5,1.5V5.25a3.75,3.75,0,0,0,7.5,0V0H7.125V5.25a1.875,1.875,0,0,1-3.75,0V0H1.5Zm8.625,9H.375A.375.375,0,0,0,0,10.874v.75A.375.375,0,0,0,.375,12h9.75a.375.375,0,0,0,.375-.375v-.75A.375.375,0,0,0,10.125,10.5Z"
				transform="translate(2283.596 9537.021)"
				fill="#515a70"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'UnderlineSvg',
};
</script>

<style scoped lang="scss"></style>
